const changesToContent = (changes) => {
  return changes?.reduce((carry, change) => {
    return `${carry} ${change}  \n\n`;
  },'');


}
export default changesToContent
